import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';
import { ComponentsModule } from '@components/components.module';
import { TableModule } from '@components/custom-table/table.module';
import { VirtualScrollerModule } from 'ngx-virtual-scroller';
import { FocusDirective } from "@app/shared/directives/forceFocus.directive";
import { FormFeatureModule } from '@components/form/form.feature.module';
import { Error404Component } from "@app/shared/components";

import { TicketCreateModalComponent, TicketDetailsModalComponent } from '@app/roles/admin/pages/ticket-management/components';
import { ToolRequestLinesToolsTableComponent } from './pages/tool-request-lines-tools-table/tool-request-lines-tools-table';
import { PendingToolRequestsModalComponent } from './pages/pending-tool-requests-modal/pending-tool-requests-modal.component';

import {
    TicketOverviewComponent
} from '@app/roles/admin/pages/ticket-management/components/ticket-create-modal/ticket-overview/ticket-overview.component';
import { DropdownMultipleComponent } from '@components/form/dropdown-multiple/dropdown-multiple.component';
import { PendingToolReturnsModalComponent } from "@app/shared/pages/pending-tool-returns-modal/pending-tool-returns-modal.component";
import { PrimeNGLibraryModule } from "@components/_libraries/_primeng-library.module";

@NgModule({
    declarations: [
        // Shared components
        TicketDetailsModalComponent,
        FocusDirective,
        Error404Component,
        ToolRequestLinesToolsTableComponent,
        PendingToolRequestsModalComponent,
        PendingToolReturnsModalComponent,
        TicketCreateModalComponent,
        DropdownMultipleComponent,
        TicketOverviewComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        HttpClientModule,
        // Feature modules
        TableModule,
        FormFeatureModule,
        ComponentsModule,
        VirtualScrollerModule,
        PrimeNGLibraryModule,
    ],
    exports: [
        CommonModule,
        // Shared components
        TicketDetailsModalComponent,
        // Feature modules
        TableModule,
        ComponentsModule,
        FormFeatureModule,
        FormsModule,
        ReactiveFormsModule,
        FocusDirective,
        Error404Component,
        ToolRequestLinesToolsTableComponent,
        PendingToolRequestsModalComponent,
        PendingToolReturnsModalComponent,
        TicketCreateModalComponent,
        DropdownMultipleComponent,
        VirtualScrollerModule,
        TicketOverviewComponent,
        PrimeNGLibraryModule
    ],
    providers: [],
    bootstrap: [],
    schemas: []
})
export class SharedModule {
}
